import { Space, Tag, Typography } from "antd";
import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";
const { Text } = Typography;

const LoginRegistration = () => {
    const loginConfig: MasterConfigs = {
        api: () => "/login-history?loginType=password-reset",
        modalTitle: () => "Login Failed",
        getColumns: () => {
            return [
                {
                    title: "Employee",
                    dataIndex: "userId",
                    key: "userId",
                    width: 200,
                    render: (text, records) => <Space direction="vertical" size={[0, 0]}>
                        <Text>{text?.firstName} {text?.lastName}</Text>
                        <Text type="secondary">{text?.workEmail}</Text>
                    </Space>,
                },
                {
                    title: "IP Address",
                    dataIndex: "ipAddress",
                    key: "ipAddress",
                    align: "center",
                    width: 130,
                },
                {
                    title: "Location",
                    dataIndex: "formatted_address",
                    key: "formatted_address",
                },
                {
                    title: "Platform",
                    dataIndex: "platform",
                    key: "platform",
                    align: "center",
                    width: 100,
                },
                {
                    title: "Login Time",
                    dataIndex: "createdAt",
                    key: "createdAt",
                    align: "center",
                    width: 150,
                    render: (text) => new Date(text).toLocaleString(),
                },
                {
                    title: "Status",
                    dataIndex: "loginStatus",
                    key: "loginStatus",
                    align: "center",
                    width: 100,
                    render: (text) => text === "failed" ? <Tag color="red" bordered={false}>Failed</Tag> : <Tag color="green" bordered={false}>Success</Tag>,
                },
                {
                    title: "Reason",
                    dataIndex: "loginFailedReason",
                    key: "loginFailedReason",
                    width: 300,
                }
            ];
        }
    }
    return (
        <MasterComponent config={loginConfig} />
    );
}

export default LoginRegistration;
